import { PictureOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { useTranslation } from "react-i18next";
import useFetch from "../../../../hooks/useFetch";
import { AxiosResponse } from "axios";
import { ResponseInterface } from "../../../../interfaces/Response.interface";
import useMessageUser from "../../../../hooks/useMessageUser";
import { useState } from "react";

const ButtonSyncPhotos = ({ getTabla, isSCU }: any) => {
    const { t } = useTranslation();
    const { showMessage } = useMessageUser();
    const { fetchApi } = useFetch();
    const [loading, setLoading] = useState(false);

    const getPhotosAbcToScuapp = async () => {
        const endpoint = isSCU ? "/comms/update_child_info_images" : "/comms/update_child_info_images_new";

        try {
            setLoading(true);
            const { data }: AxiosResponse<ResponseInterface> = await fetchApi({
                url: endpoint,
            });

            if (data.status === "success") {
                getTabla();
            } else {
                showMessage(data?.message, "info");
            }
        } catch (error: any) {
            showMessage(error?.message || "Error", "error");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Button
            type="link"
            onClick={getPhotosAbcToScuapp}
            loading={loading}
        >
            <PictureOutlined /> {t("getPhotos")}
        </Button>
    );
};

export default ButtonSyncPhotos;
